const KEY = 'lastPromptId';

/** Возвращает _id последнего выбранного промпта суммаризации или null. */
export function getLastPromptId() {
  try {
    return localStorage.getItem(KEY) || null;
  } catch {
    return null;
  }
}

/** Сохраняет _id последнего выбранного промпта суммаризации (переживает закрытие браузера). */
export function setLastPromptId(id) {
  try {
    if (id) localStorage.setItem(KEY, id);
  } catch {
    // localStorage недоступен (приватный режим / переполнение) — молча игнорируем
  }
}

/**
 * Определяет промпт для предвыбора при загрузке вкладки «Протокол».
 * Приоритет: выбор в текущей сессии → последний сохранённый (если промпт ещё
 * существует) → серверный дефолт-звезда → первый системный. Каждый кандидат
 * валидируется по наличию в списке — устаревший _id (промпт удалён) пропускается.
 * @returns {string|null} _id промпта или null, если промптов нет.
 */
export function resolveInitialPromptId({ sessionPromptId, lastPromptId, defaultPromptId, prompts }) {
  const list = prompts || [];
  const exists = (id) => !!id && list.some((p) => p._id === id);
  if (exists(sessionPromptId)) return sessionPromptId;
  if (exists(lastPromptId)) return lastPromptId;
  if (exists(defaultPromptId)) return defaultPromptId;
  return list.find((p) => p.type === 'system')?._id ?? null;
}
